import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex-start"
};
const _hoisted_2 = ["title", "onClick"];
const _hoisted_3 = {
  class: "max-w-[260px] leading-5 whitespace-pre-wrap"
};
const _hoisted_4 = {
  class: "item-main"
};
const _hoisted_5 = {
  class: "item-title"
};
const _hoisted_6 = {
  class: "item-price"
};
const _hoisted_7 = {
  key: 1,
  class: "item-desc"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted, computed, inject } from 'vue';
import { Check } from '@element-plus/icons-vue';
export default {
  __name: 'Tab2Dialog',
  props: {
    mediaOptions: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    // 是否在选项上展示点数（海外媒体发布用，内贸臻选不展示）
    showPrice: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clickSure'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    // 点数格式化：去掉小数尾零（"500.00" → 500），非法值返回空串
    const fmtPrice = price => {
      const n = Number(price);
      return Number.isFinite(n) ? n : '';
    };
    const dialogVisible = ref(false);
    const activeItem = ref({});
    let selectFile = null;
    const emit = __emit;
    const openDialog = file => {
      dialogVisible.value = true;
      if (!file) {
        props.mediaOptions.forEach(item => {
          item.child.forEach(citem => {
            citem.checked = false;
          });
        });
      } else {
        props.mediaOptions.forEach(item => {
          item.child.forEach(citem => {
            if (props.type == '臻选媒体') {
              citem.checked = file?.selectedMediaIds?.includes(citem.itemID);
            } else if (props.type == '自媒体') {
              citem.checked = file?.selfMediaIds?.includes(citem.itemID);
            }
          });
        });
      }
      selectFile = file;
    };
    const handleClick = selectItem => {
      selectItem.checked = !selectItem.checked;
    };

    // 分组内存在服务项描述时（海外媒体），卡片统一高度，避免有无描述的行高不齐
    const hasRemark = item => (item.child || []).some(cItem => cItem.remark);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleSure = () => {
      dialogVisible.value = false;
      const selectMedia = [];
      props.mediaOptions.forEach(item => {
        item.child.forEach(citem => {
          if (citem.checked) {
            selectMedia.push(citem);
          }
        });
      });
      emit('clickSure', selectMedia, selectFile);
    };

    // 生命周期
    onMounted(() => {});
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "geo-dialog",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "批量设置",
        width: "860px",
        "close-on-click-modal": false,
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "info",
          text: "",
          bg: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSure
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("确定", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "alert-hint"
        }, " 温馨提示：批量设置操作后将对所有文章生效，如果需要个性化操作请在单篇文章进行操作 ", -1)), _createVNode(_component_el_scrollbar, {
          class: "media-list",
          height: "50vh"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaOptions, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              class: "flex",
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 3,
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                span: 21
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", {
                  class: _normalizeClass(["newList", {
                    'has-desc': hasRemark(item)
                  }])
                }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (cItem, i) => {
                  return _openBlock(), _createElementBlock("li", {
                    title: cItem.remark ? undefined : cItem.title,
                    key: i,
                    onClick: $event => handleClick(cItem)
                  }, [_createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "dark",
                    "show-after": 150,
                    disabled: !cItem.remark
                  }, {
                    content: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(cItem.remark), 1)]),
                    default: _withCtx(() => [_createElementVNode("span", {
                      class: _normalizeClass({
                        isPay: cItem.checked
                      })
                    }, [cItem.checked ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      class: "check-badge"
                    }, {
                      default: _withCtx(() => [_createVNode(_unref(Check))]),
                      _: 1
                    })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(cItem.title), 1), props.showPrice && cItem.price != null ? (_openBlock(), _createElementBlock(_Fragment, {
                      key: 0
                    }, [_cache[1] || (_cache[1] = _createElementVNode("i", {
                      class: "item-divider"
                    }, null, -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(fmtPrice(cItem.price)) + "点", 1)], 64)) : _createCommentVNode("", true)]), cItem.remark ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(cItem.remark), 1)) : _createCommentVNode("", true)], 2)]),
                    _: 2
                  }, 1032, ["disabled"])], 8, _hoisted_2);
                }), 128))], 2)])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};